import { render, staticRenderFns } from "./GrowtradeRegister.vue?vue&type=template&id=4d09b3c8&scoped=true&"
import script from "./GrowtradeRegister.vue?vue&type=script&lang=js&"
export * from "./GrowtradeRegister.vue?vue&type=script&lang=js&"
import style0 from "./GrowtradeRegister.vue?vue&type=style&index=0&id=4d09b3c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09b3c8",
  null
  
)

export default component.exports